










































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { decodeHTML } from '../../utils/decodeHTML';
import { default as egText } from '../../directives/text';
import { CourseStatus, ICourse } from '../../types/types';
import Avatar from '@/components/Avatar.vue';
import Button from '@/components/Button.vue';
import CourseCover from '@/components/courses/CourseCover.vue';

@Component({ components: { Avatar, Button, CourseCover }, directives: { egText } })
export default class Card extends Vue {
  @Prop() course!: ICourse;

  @Prop({ default: 255 }) titleLength!: number;

  @Prop() cardView!: string;

  CourseStatus = CourseStatus;

  ImageCover = this.course.coverPictureUrl || require('@/assets/images/course/default-cover.jpg');

  get currentSearch(): string {
    return this.$store.getters['courses/options'].search;
  }

  get courseTitleId(): string {
    return `course-title-${this.course.courseId}`;
  }

  getDecodedHTMLValue(value: string) {
    return decodeHTML(value);
  }

  decodeHTML(text: string) {
    const element = document.createElement('div');
    element.textContent = text;
    return element.innerHTML;
  }
}
